export default "__VITE_ASSET__enxIXRLv__"